// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"56f739a1","453":"53a68949","455":"c0728a05","977":"373615df"}[chunkId] + ".chunk.js";
};